/**
 * Collection pages: tint the cream page background to a light mix of the
 * hovered product card's --noa-product-hover accent.
 */
(function () {
  if (!document.body || !document.body.classList.contains('template-collection')) return;

  var canHover =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  var root = document.documentElement;
  var cardSelector = 'product-card.grid-view-item, #template--collection .grid-view-item';
  var activeCard = null;

  function accentFrom(card) {
    if (!card) return '';
    return getComputedStyle(card).getPropertyValue('--noa-product-hover').trim();
  }

  function activate(card) {
    if (!card || activeCard === card) return;
    var accent = accentFrom(card);
    if (!accent) return;

    activeCard = card;
    root.style.setProperty('--noa-collection-hover-accent', accent);
    root.classList.add('has-noa-collection-hover');
  }

  function clear() {
    activeCard = null;
    root.classList.remove('has-noa-collection-hover');
    root.style.removeProperty('--noa-collection-hover-accent');
  }

  function deactivate(relatedTarget) {
    var next =
      relatedTarget && relatedTarget.closest ? relatedTarget.closest(cardSelector) : null;
    if (next && document.body.contains(next)) {
      activate(next);
      return;
    }
    clear();
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      var card = event.target.closest && event.target.closest(cardSelector);
      if (!card) return;
      activate(card);
    },
    { passive: true },
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var card = event.target.closest && event.target.closest(cardSelector);
      if (!card) return;
      if (event.relatedTarget && card.contains(event.relatedTarget)) return;
      deactivate(event.relatedTarget);
    },
    { passive: true },
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var card = event.target.closest && event.target.closest(cardSelector);
      if (card) activate(card);
    },
    { passive: true },
  );

  document.addEventListener(
    'focusout',
    function (event) {
      var card = event.target.closest && event.target.closest(cardSelector);
      if (!card) return;
      if (event.relatedTarget && card.contains(event.relatedTarget)) return;
      deactivate(event.relatedTarget);
    },
    { passive: true },
  );
})();
